import { Flex, Switch, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type ShowMarkersToggleProps = {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};

export default function ShowMarkersToggle({ checked, onChange, disabled }: ShowMarkersToggleProps) {
  return (
    <Flex
      bg="white"
      h={28}
      pl="xs"
      pr="xxs"
      style={{ borderRadius: 'var(--mantine-radius-xl)' }}
      align="center"
      gap="xxxs"
    >
      <Text
        size="sm"
        fw={FONT_WEIGHTS.medium}
        c={disabled ? 'gray.4' : 'black'}
        style={{ whiteSpace: 'nowrap' }}
      >
        Show markers
      </Text>
      <Switch
        size="xs"
        checked={disabled ? false : checked}
        onChange={e => onChange(e.currentTarget.checked)}
        color={disabled ? 'gray.4' : 'brand.6'}
        disabled={disabled}
      />
    </Flex>
  );
}
